module.exports = __webpack_public_path__ + "media/fonts/bootstrap-icons-b2e5aab643c6f0fd2da69dc383322a8f.woff2";